var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"image_amplify"},[(_vm.dialogVisible)?_c('div',{staticClass:"image_box_main"},[_c('div',{staticClass:"main_image"},[_c('img',{attrs:{"src":_vm.img,"alt":""}}),_c('div',{staticClass:"img_close"},[_c('div',{staticClass:"close",on:{"click":_vm.closeBtn}},[_c('i',{staticClass:"el-icon-close"})])])])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }